// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".three--MOi4i {\n  width: 2rem;\n}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Networks/Three/index.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".three {\n  width: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"three": "three--MOi4i"
};
export default ___CSS_LOADER_EXPORT___;
